import React, {useState,useEffect,useRef} from "react";
import {Card, CardBody, Table, Alert, CardHeader} from "reactstrap";
import {Link, Route, Switch} from 'react-router-dom';
import Loader from "./Loader/Loader";
import {connect} from "react-redux";
import {sportsService} from "./../redux/sports/services";
import Breadcrumbs from "./Breadcrumb";

import {Accordion, Button} from 'react-bootstrap'

const League = (props) => {
    const [sportId, setSportId] = useState(props.match.sportId);
    const [isLoading, setIsLoading] = useState(true);
    const [leagues, setLeagues] = useState([]);
    const elementRef = useRef(null);
    const isMounted = useRef(true);
  
    useEffect(() => {
      fetchLeaguesList(sportId);
  
      return () => {
        isMounted.current = false;
      };
    }, [sportId]);
  
    const fetchLeaguesList = (sportId) => {
      sportsService.leaguesList(sportId).then((response) => {
        if (isMounted.current) {
          setIsLoading(false);
          setLeagues(response.data);
        }
      }).catch((error) => {
        console.log(error);
      });
    };
  
    return (
      <Card>
        <CardHeader>LEAGUES</CardHeader>
        <CardBody>
          {isLoading && <Loader />}
          {!isLoading && leagues.length === 0 && (
            <Alert color="dark" className="text-center">No Data found.</Alert>
          )}
          {!isLoading && leagues.length > 0 && (
            <Table>
              {/* Render league data here */}
            </Table>
          )}
        </CardBody>
      </Card>
    );
  };
  
  export default League;